import { message } from 'antd';
import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';

import { ResponseDTO } from '@/types';

import { envConfig } from '@/config/env';

export const SuccessCode = 200;
export const InvalidTokenCode = 401;
export const PointsNotEnoughCode = 6000;

// 创建 axios 实例
const request: AxiosInstance = axios.create({
  baseURL: envConfig.apiBaseUrl || '/api',
  timeout: 300000,
});

// 请求拦截器
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = window.config?.token;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const data = response.data as ResponseDTO<unknown>;
    if (data.code === SuccessCode) {
      return data as any;
    } else if (data.code === InvalidTokenCode) {
      // 登录已过期，跳转到登录页
      window.location.href = `/login?from=${encodeURIComponent(window.location.href)}`;
      throw new Error('登录已过期');
    } else {
      if (data.code !== PointsNotEnoughCode) {
        message.error(data.message || '请求失败');
      }
      throw new Error(data.message + '');
    }
  },
  (error: AxiosError<ResponseDTO<unknown>>) => {
    if (error.response) {
      const { data } = error.response;
      message.error(data?.message || '请求失败');
    } else {
      message.error('网络错误，请稍后重试');
    }
    return Promise.reject(error);
  },
);

export default request;
